/**
 * Customer Settings V2 — "Attachments" section: document/file
 * attachments via the shared `BinaryFileGrid`.
 *
 * Contains:
 * - AttachmentsSection (default export)
 */

import AttachFileIcon from '@mui/icons-material/AttachFile';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BinaryFileGrid, SettingsSection } from '@sophocles/views/settings/components';

import { staffOnlyChip } from './chips';

export default function AttachmentsSection({ customer, canWrite }) {
  const { t } = useTranslation();
  return (
    <SettingsSection
      id="settings-attachments"
      icon={<AttachFileIcon />}
      title={t('customerSettings.v2.attachments', 'Attachments')}
      description={t('customerSettings.attachmentsDescription', 'Documents and file attachments.')}
      chip={staffOnlyChip(t)}
    >
      <BinaryFileGrid
        entityType="customer"
        entityId={customer?.get?.('id') ?? customer?.id}
        fileType="attachment"
        uploadLabel={t('attachments.uploadAttachment', 'Upload Attachment')}
        emptyText={t('attachments.emptyState', 'No attachments yet — upload one to get started.')}
        canWrite={canWrite}
      />
    </SettingsSection>
  );
}
